import React, { useEffect, useState } from 'react';
import CollectionFieldForm from './CollectionFieldForm';
import { getCurrentEnvironment } from './Util';

export const CollectionFieldRow = ({
  createNewParamRow,
  fields,
  params,
  utilities,
  collectionName,
  version,
  isMultiTenantPluginInstalled,
  projectId,
  events,
  envRefreshCounter,
}) => {
  const [paramArr, setParamArr] = useState([]);
  useEffect(() => {
    const currentEnvironment = getCurrentEnvironment();
    const filteredParams = params.filter((p) => {
      const needsEnvCheck = ['dynamic_option', 'reference'].includes(p.fieldType);
      if (!needsEnvCheck) return true;
      return !p.environment || p.environment === currentEnvironment;
    });
    setParamArr(filteredParams);
  }, [params, envRefreshCounter]);

  return (
    <>
      <div className="table-responsive">
        <table className="table table-sm table-bordered table-condensed">
          <thead style={{ fontWeight: 'bold' }}>
            <tr>
              <td className="text-left" width="26%">
                Field
              </td>
              <td className="text-left" width="30%">
                Value From
              </td>
              <td className="text-left" width="22%">
                Value
              </td>
              <td className="text-left" width="22%">
                Action
              </td>
            </tr>
          </thead>
          <tbody>
            {paramArr.map((row) => {
              return (
                <CollectionFieldForm
                  paramRow={row}
                  key={row.id}
                  createNewRow={createNewParamRow}
                  fields={fields}
                  utilities={utilities}
                  collectionName={collectionName}
                  projectId={projectId}
                  version={version}
                  isMultiTenantPluginInstalled={isMultiTenantPluginInstalled}
                  events={events}
                />
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};
